"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Nissan = function Nissan(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.036 1.728c-4.896 0-9.024 3.24-10.224 7.632-.516.06-.768.096-.984.156-.684.156-.828.396-.828.888v3.324c0 .48.516.816.876.876.36.072.588.096.96.132h.004c1.24 4.35 5.329 7.536 10.196 7.536 4.866 0 8.965-3.196 10.195-7.543a8.07 8.07 0 00.893-.125c.36-.06.876-.396.876-.876v-3.324c0-.492-.144-.732-.828-.888-.206-.057-.451-.093-.919-.148a.074.074 0 01-.005-.032c-1.212-4.392-5.328-7.608-10.212-7.608zm.012 2.424c3.456 0 6.408 2.112 7.56 5.076 0 .012.012.024.012.024l.014.005c-2.49-.094-5.706-.197-7.634-.197-1.902 0-5.052.1-7.529.193l.005-.001c1.152-2.976 4.104-5.1 7.572-5.1zm-5.652 6.516h.648c.06 0 .072.024.072.072v2.52c0 .06-.012.084-.084.084H6.42c-.072 0-.084-.012-.084-.084v-2.52c0-.048.012-.072.06-.072zm2.148.012h1.92c.072 0 .096.012.096.072v.432c0 .06-.024.084-.096.072H8.58c-.084 0-.12.036-.132.12v.108c0 .06.036.108.12.12.216.036.912.084 1.176.108.468.048.816.132.912.576 0 .036.012.156.012.288 0 .084 0 .192-.024.288-.084.42-.396.504-.9.504h-1.98c-.072 0-.084-.012-.084-.084v-.42c0-.072.012-.084.084-.084h2.004c.084 0 .108-.024.12-.084v-.18c-.012-.048-.024-.12-.132-.132a35.656 35.656 0 01-1.332-.12c-.576-.06-.72-.3-.744-.516-.012-.072-.012-.168-.012-.252 0-.072 0-.18.012-.264.084-.372.36-.552.864-.552zm3.408 0h1.92c.072 0 .096.012.096.072v.432c0 .06-.024.084-.096.072h-1.884c-.084 0-.12.036-.132.12v.108c0 .06.024.108.12.12.216.036.912.084 1.164.108.468.048.816.132.912.576 0 .036.012.156.012.288 0 .084 0 .192-.024.288-.084.42-.396.504-.9.504h-1.968c-.072 0-.084-.012-.084-.084v-.42c0-.072.012-.084.084-.084h2.004c.084 0 .108-.024.12-.084v-.18c-.012-.048-.036-.12-.132-.132a35.65 35.65 0 01-1.332-.12c-.576-.06-.708-.3-.744-.516-.012-.072-.012-.168-.012-.252 0-.072 0-.18.012-.264.084-.372.36-.552.864-.552zm-9.324.012h.612c.456 0 .516-.012.684.228.132.216 1.2 1.86 1.2 1.86v-2.004c0-.06.012-.084.084-.084h.528c.072 0 .084.024.084.084v2.508c0 .072-.012.084-.084.084h-.72c-.42 0-.456 0-.6-.24-.288-.456-1.176-1.812-1.176-1.812v1.968c0 .072-.012.084-.084.084h-.528c-.072 0-.084-.012-.084-.084v-2.508c0-.06.012-.084.084-.084zm13.416 0c.132 0 .228 0 .264.012.432.012.36-.036.564.408.108.252.876 1.896.996 2.184.036.084.012.072-.084.072h-.66c-.036 0-.072-.012-.084-.048 0-.012-.084-.204-.204-.48h-1.548c-.12.276-.216.48-.216.48-.012.024-.036.048-.084.048h-.636c-.096 0-.132 0-.072-.12l.012-.024c.3-.66 1.008-2.244 1.008-2.244.144-.3.072-.276.48-.276.108-.012.132-.012.264-.012zm2.304 0h.612c.456 0 .516-.012.684.228.144.216 1.2 1.86 1.2 1.86v-2.004c0-.06.012-.084.084-.084h.528c.072 0 .084.024.084.084v2.508c0 .072-.012.084-.084.084h-.72c-.42 0-.456 0-.6-.24-.3-.456-1.176-1.812-1.176-1.812v1.968c0 .072-.012.084-.084.084h-.528c-.072 0-.084-.012-.084-.084v-2.508c0-.06.012-.084.084-.084zm-2.268.6c-.036 0-.072 0-.084.012-.036 0-.06.012-.072.036 0 .012-.192.468-.396.936h1.068c-.156-.396-.336-.792-.384-.924-.012-.036-.036-.048-.06-.048-.012-.012-.048-.012-.072-.012zm3.48 3.59c-.003.014-.024.047-.024.058-1.2 2.88-4.104 4.92-7.5 4.92-3.42 0-6.336-2.064-7.524-4.968l-.023-.007c2.176.11 4.994.223 7.511.223 2.538 0 5.376-.114 7.56-.225Z"
  }));
};

Nissan.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Nissan.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Nissan;
exports.default = _default;